// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React, { memo } from "react"
import * as styles from "./styles.module.scss"

interface Props {
  onClick: any
  className?: string
}

const LinkButton: React.FC<Props> = ({ className, children, onClick }) => {
  return (
    <button className={`${styles.linkBtn} ${className}`} onClick={onClick}>
      {children}
    </button>
  )
}

export default memo(LinkButton)
